import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ScreenResolutionService } from '../../shared/services/screen-resolution/screen-resolution.service';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { SeoService } from '../../shared/services/seo-service/seo.service';
import { AuthServiceService } from '../../shared/services/auth-service/auth-service.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
  sidebarVisible: boolean = false;
  isBrowser = false;
  constructor(
    private seo: SeoService,
    @Inject(PLATFORM_ID) platformId: Object,
    public screenResolution: ScreenResolutionService,
    private router: Router,
    private authService: AuthServiceService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.seo.update({
      title:
        'Coinwush | Professional Crypto Futures & Options Trading Platform',
      description:
        'Coinwush is a professional crypto derivatives exchange offering futures and options trading with INR settlement, low fees, advanced risk controls, and institutional-grade performance.',
      keywords:
        'Coinwush, crypto derivatives exchange, crypto futures trading, crypto options trading, INR crypto trading, professional crypto exchange',
      url: 'https://coinwush.com',
    });
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }

  addFunds() {
    if (!this.authService.isLogin()) {
      this.navigate('/user/login');
    } else {
      this.navigate('/dashboard');
    }
  }
}
